import isEmpty from "lodash/isEmpty";

import store from 'flux'

const validate = values => {
  let errors = {
    employmentHistory: []
  };

  let requiredFields = [
    "company",
    "phone",
    "startDate",
    "streetAddress",
    "city",
    "state",
    "zipCode",
    "position",
    "majorDuties",
    "currentEmployer",
    "reasonForLeaving",
    "supervisor",
    "canContactEmployer"
  ];

  if (store.getState().config.askAboutWages) {
    requiredFields = requiredFields.concat(["startingWage", "endingWage"]);
  }

  if (values.employmentHistory) {
    values.employmentHistory.forEach(function (history, index) {
      let historyErrors = {};
      requiredFields.forEach(function (field) {
        if (isEmpty(history[field])) {
          historyErrors[field] = 'Required';
        }
      });

      //check phone
      if (history.phone) {
        const onlyNums = history.phone.replace(/[^\d]/g, '');
        if (onlyNums.length < 10) {
          historyErrors.phone = "Valid phone number required"
        }
      }

      //zipCode
      if (history.zipCode && !/^\d{5}(?:[-\s]\d{4})?$/.test(history.zipCode)) {
        historyErrors.zipCode = "Valid Zip Code is required"
      }

      // reason for Leaving
      console.log(history);
      if ((!history.currentEmployer || history.currentEmployer == "false") && !history.reasonForLeaving) {
        historyErrors.reasonForLeaving = "Required";
      }

      if (!isEmpty(historyErrors)) {
        errors.employmentHistory[index] = historyErrors;
      }
    });
  }

  if (isEmpty(errors.employmentHistory)) {
    delete errors.employmentHistory;
  }


  return errors
}

export default validate